import { Box } from '#/components/Box/Box';
import { LoadingSection } from '#/components/LoadingSection/LoadingSection';
import type { CmsApiRecommendedActionsBlockData } from '#/modules/cms/api/types/blocks/CmsApiRecommendedActionsBlock';
import { dynamic } from '#/utils/dynamic';

const DynamicCmsRecommendedActionsBlockContent = dynamic(
  () =>
    import('./CmsRecommendedActionsBlockContent').then((m) => ({
      default: m.CmsRecommendedActionsBlockContent,
    })),
  { strategy: 'client-only', placeholder: <LoadingSection /> },
);

type Props = {
  data: CmsApiRecommendedActionsBlockData;
};

export function CmsRecommendedActionsBlock({ data }: Props) {
  const { volopFunction, areaOfFocus } = data;

  return (
    <Box
      qaId="recommended-actions"
      data-qa-volop-function={volopFunction}
      data-qa-area-of-focus={areaOfFocus}
    >
      <DynamicCmsRecommendedActionsBlockContent data={data} />
    </Box>
  );
}
